import React from 'react';
import './SienBanner.css';

const FANBOX_URL = 'https://asmrchurch.fanbox.cc';

function SienBanner({ className }) {
  const wrapperClass = className ? `sien-banner-wrap ${className}` : 'sien-banner-wrap';

  return (
    <p className={wrapperClass}>
      <a href={FANBOX_URL} target="_blank" rel="noopener noreferrer">
        <img
          className="sien-banner"
          src="/static/images/sien.png"
          alt="Fanbox（支援はこちら）"
        />
      </a>
    </p>
  );
}

export default SienBanner;
